import React from 'react';

import ErrorIcon from 'src/Common/SVG/ErrorIcon';

import './Input.css';

import PropTypes from 'prop-types';

const Input = (props) => {

  const inputClasses = ['input-box'];

  if (!props.isValid && props.isTouched) {

    inputClasses.push('input-element-invalid');
  }

  return (

    <div style={{ width: `${props.width}%`, paddingBottom: '16px' }}>

      { props.label &&
  
        <span className={'input-label-text'}>

          {props.label}
        </span>
      }

      <input
        {...props.config}
        value={props.value}
        className={inputClasses.join(' ')}
        onChange={(e) => props.updateValue(e.target.value, props.inputIdentifier)}
        onFocus={props.onFocus ? (e)=>{props.onFocus(e)} : null}
        onBlur={props.onBlur ? (e)=>{props.onBlur(e)} : null} />
      
      { !props.isValid && props.isTouched &&

        <span className={'invalid-msg-wrapper'}>

            <ErrorIcon/>

            <span className={'invalid-msg'}>

              {props.validations.invalidMessage}
            </span>

        </span>
      }
    </div>
  )
}

Input.propTypes = {
  config: PropTypes.shape({
    type: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    tabIndex: PropTypes.string,
  }),
  inputIdentifier: PropTypes.string,
  isTouched: PropTypes.bool,
  isValid: PropTypes.bool,
  note: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  updateValue: PropTypes.func,
  validations: PropTypes.shape({
    type: PropTypes.string,
    required: PropTypes.bool,
    invalidMessage: PropTypes.string
  }),
  value: PropTypes.string,
  width: PropTypes.number,
};

export default Input;